<template>
    <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <section class="blog-area pt-50 pb-50">
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <div
              class="section-title text-center mb-5 wow fadeInUp2 animated"
              data-wow-delay=".1s"
              :style="locale == 'en' ? 'text-align: left !important' : ''"
            >
              <h6>
                <span :style="[locale == 'en' ? { left: 'auto' } : {}]">
                  <i class="fas fa-newspaper"></i>
                </span>
                {{ info.title }}
              </h6>
              <h2 v-html="info.body"></h2>
            </div>
          </div>
        </div>

        <carousel
          class="home-blog-carousel"
          v-if="!pgLoading && rows"
          :rtl="$i18n.locale == 'ar' ? true : false"
          :autoplay="true"
          :items="3"
          :loop="true"
          :margin="20"
          :nav="false"
          :center="true"
          :responsive="{
            0: { items: 1 },
            767: { items: 1 },
            1000: { items: 3 },
          }"
          :dots="false"
        >
          <div
            v-for="(row, idx) in rows"
            :key="idx"
            class="item wow fadeInUp2 animated"
            data-wow-delay=".3s"
          >
            <div class="blog mb-30">
              <div class="blog__thumb mb-40">
                <router-link
                  :to="{ name: 'show-news', params: { slug: row.slug } }"
                >
                  <img
                    :src="
                      row.image
                        ? row.image.url
                        : '/assets/img/logo/min-logo.png'
                    "
                    loading="lazy"
                    alt=""
                    @error="handleImageError"
                    style="aspect-ratio: 16 / 9;"
                  />
                </router-link>
              </div>
              <div class="blog__content">
                <!-- <a class="tag" href="#">اعمال خيرية</a> -->
                <a :style="$i18n.locale == 'ar' ? 'float:left' : 'float:right'">
                  <i class="far fa-calendar-alt"></i> {{ row.date }}
                </a>
                <p></p>
                <h3 class="blog-title mb-15 project-desc">
                  <router-link
                    :to="{ name: 'show-news', params: { slug: row.slug } }"
                    class="blog-btn-one"
                  >
                    {{ row.title }}
                  </router-link>
                </h3>
                <p class="mb-25 project-desc" v-html="row.short_body"></p>
                <!-- <ul class="blog-author">
                                    <li>
                                        <a href="#">
                                            <img src="/assets/img/team/01.png" alt="" />
                                            <span>عبد المحسن المطيري</span>
                                        </a>
                                    </li>
                                    <li><i class="far fa-calendar-alt"></i> 25 Dec 2020</li>
                                </ul> -->
              </div>
            </div>
          </div>
        </carousel>
      </div>
    </section>
  </div>
</template>

<script>
import carousel from "v-owl-carousel";

export default {
  name: "LatestNews",
  components: {
    carousel,
  },
  data() {
    return {
      //
      auth: {
        access_token: "",
      },
      pgLoading: false,
      info: "",
      rows: [],
      locale: "ar",
    };
  },
  watch: {
    //
  },
  created() {
    //
    if (localStorage.getItem("access_token")) {
      this.auth.access_token = localStorage.getItem("access_token");
    }
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }
    this.fetchData();
  },
  methods: {
    handleImageError(event) {
      event.target.src = "/assets/img/logo/min-logo.png";
    },
    //
    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/news",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          status: "active",
          paginate: 100,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.info = res.data.info;
          this.rows = res.data.rows;
        })
        .catch(() => {})
        .finally(() => {});
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
